export default __webpack_public_path__ + "static/media/modal-2021.c8b48263.pdf";